// extracted by mini-css-extract-plugin
module.exports = {"share":"CopyShare_share__2aJt3","copied":"CopyShare_copied__3yOBa","alert":"CopyShare_alert__GIMCj","show":"CopyShare_show__2L5ea"};